import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LOCAL_ORG_USER, TRAINING_PRODUCT_TYPES } from '../../../../../constants';
import { useActiveProduct } from '../../../../../helpers/customHook';
import { tryParseJSON } from '../../../../../utils';
import { fetchSubscriberProductsRequest } from '../../../Subscriber/Products/actions';
import { fetchOrganizationCoursesRequest } from '../../OrganizationCourses/actions';
import OnlineCourses from '../CourseTypes/OnlineCourses';
import OnlineLiveTraining from '../CourseTypes/OnlineLiveTraining';
import PhysicalProduct from '../CourseTypes/PhysicalProduct';
import Bundle from '../CourseTypes/Bundle';
import { fetchListOrganizationSeatsRequest } from '../OrganizationSeats/actions';

const TrainingSeatDetails = () => {
     const dispatch = useDispatch();
     const products = useSelector((state) => state.subscriber.products.list);
     const organizationCourses = useSelector((state) => state.subscriber.organizationCourses);
     const listOrganizationSeats = useSelector((state) => state.subscriber.listOrganizationSeats);

     const orgUserLocalStorage = tryParseJSON(localStorage.getItem(LOCAL_ORG_USER));
     const organizationId = orgUserLocalStorage?.organizationId;

     const product = useActiveProduct();
     const relatedProduct = products?.find((item) => item.id === product?.relatedProductProductId);
     const alternativeProduct = products?.find((item) => item.id === product?.relatedAlternateProductId);
     const trainingProductType = product?.productType?.trainingProductType;

     const fetchProducts = () => {
          if (!products.length) {
               dispatch(fetchSubscriberProductsRequest());
          }
     };

     const fetchOrganizationCourses = () => {
          if (!organizationCourses?.length && organizationId) {
               dispatch(fetchOrganizationCoursesRequest(organizationId));
          }
     };

     const fetchListOrganizationSeats = () => {
          const isNeedFetchData = !listOrganizationSeats || listOrganizationSeats.some((seat) => seat.organizationId !== organizationId);

          if (organizationId && isNeedFetchData) {
               dispatch(fetchListOrganizationSeatsRequest(organizationId));
          }
     };

     useEffect(() => {
          fetchListOrganizationSeats();
     }, [organizationId, listOrganizationSeats]); // eslint-disable-line react-hooks/exhaustive-deps

     useEffect(() => {
          fetchProducts();
          fetchOrganizationCourses();
          fetchListOrganizationSeats();
     }, [organizationId]); // eslint-disable-line react-hooks/exhaustive-deps

     switch (trainingProductType) {
          case TRAINING_PRODUCT_TYPES.PHYSICAL_PRODUCT:
          case TRAINING_PRODUCT_TYPES.DIGITAL_DOWNLOAD:
          case TRAINING_PRODUCT_TYPES.PURCHASE_DIGITAL_DOWNLOAD:
               return <PhysicalProduct product={product} relatedProduct={relatedProduct} alternativeProduct={alternativeProduct} />;
          case TRAINING_PRODUCT_TYPES.LIVE_TRAINING:
               return <OnlineLiveTraining />;
          case TRAINING_PRODUCT_TYPES.ONLINE_COURSE:
          case TRAINING_PRODUCT_TYPES.SURVEY_ONLY:
          case TRAINING_PRODUCT_TYPES.TEST_ONLY:
          case TRAINING_PRODUCT_TYPES.CE_CREDITS:
               return <OnlineCourses product={product} relatedProduct={relatedProduct} />;
          case TRAINING_PRODUCT_TYPES.BUNDLE:
               return <Bundle product={product} />;
          default:
               return <></>;
     }
};

export default TrainingSeatDetails;
